export interface ILeaderboardRow {
  position: number;
  name: string;
  date: string;
  matchId: string;
  userId: string;
  id: number;
  score: number;
  refId: string;
}